module.exports = __webpack_public_path__ + "static/img/lixian.f694ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/lixian.png
// module id = 5U81
// module chunks = 24